import SauvegardeManager from "../../SauvegardeManager";
import Dot from "./Dot";
// import ChiffreCode from "./ChiffreCode";

export default class Ordi extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        this.isDragging = false;
        this.linesGroup = this.scene.add.group();
        this.dots = []

        // Gestion de la progression
        this.sauvegardeManager = new SauvegardeManager()
        this.progression = this.sauvegardeManager.getChapitreProgression("Chapitre4")["ordi"];
        this.config = this.scene.cache.json.get('config')['Chapitre4']['ordi']

        // Ajout fond ordi
        this.background = this.scene.add.image(0, 0, 'Chapitre4_ordi_background').setOrigin(0.5, 0);
        this.background.setInteractive();
        this.add(this.background);

        // Ajout article linkedin
        let article = this.scene.add.image(190, this.background.height - 160, 'Chapitre4_ordi_article').setOrigin(0.5, 1);
        this.add(article);

        // Ajout liens externes (google, wikipedia, etc)
        this.icons = []
        this.addIcons()

        this.setSize(this.background.width, this.background.height);

        // Ajout code si ordi locked
        if(this.progression.locked){
            this.lockButtons();
            this.setLocked()
        }
    }

    update(){
        if(this.line && this.isDragging){
            this.line.setTo(this.line.x1, this.line.y1, this.scene.input.activePointer.x - this.scene.width/2 - this.line.x, this.scene.input.activePointer.y - this.y - this.line.y)
            this.line.circle.x = this.scene.input.activePointer.x - this.scene.width/2 
            this.line.circle.y = this.scene.input.activePointer.y - this.y
        }
    }

    animIn(endFunc){
        let audi = 'OrdiLocked'
        if(!this.progression.locked){
            audi = 'OrdiUnlocked'
        }
        this.soundManager.playOnce(audi)
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: this.scene.height - this.height,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    animOut(endFunc){
        this.soundManager.playOnce('OrdiClosed')
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: this.y + 200,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    // Block
    lockButtons(){
        this.icons.forEach( button => {
            button.disableInteractive();
        })
    }

    unlockButtons(){
        this.icons.forEach( button => {
            button.setInteractive({useHandCursor: true});
        })
    }

    isLocked() {
        return this.progression.locked;
    }

    setLocked(){
        this.lockedContainer = this.scene.add.container(0, 0, [])
        this.add(this.lockedContainer);

        // Modif du fond
        this.backgroundLocked = this.scene.add.image(0, 0, 'Chapitre4_ordi_code').setOrigin(0.5, 0);
        this.backgroundLocked.setInteractive();
        this.lockedContainer.add(this.backgroundLocked);

        // Ajout du code à rentrer
        const DX = 190
        const DY = 190

        let dot0 = new Dot(this.scene, this, -210, 333, 0)
        this.add(dot0)
        this.lockedContainer.add(dot0)

        let dot1 = new Dot(this.scene, this, dot0.x + DX, dot0.y, 1)
        this.add(dot1)
        this.lockedContainer.add(dot1)

        let dot2 = new Dot(this.scene, this, dot0.x + 2 * DX, dot0.y, 2)
        this.add(dot2)
        this.lockedContainer.add(dot2)

        let dot3 = new Dot(this.scene, this, dot0.x , dot0.y + DY, 3)
        this.add(dot3)
        this.lockedContainer.add(dot3)

        let dot4 = new Dot(this.scene, this, dot0.x + DX, dot0.y + DY , 4)
        this.add(dot4)
        this.lockedContainer.add(dot4)

        let dot5 = new Dot(this.scene, this, dot0.x + 2* DX, dot0.y + DY , 5)
        this.add(dot5)
        this.lockedContainer.add(dot5)

        let dot6 = new Dot(this.scene, this, dot0.x , dot0.y + 2*DY, 6)
        this.add(dot6)
        this.lockedContainer.add(dot6)

        let dot7 = new Dot(this.scene, this, dot0.x + DX, dot0.y + 2*DY, 7)
        this.add(dot7)
        this.lockedContainer.add(dot7)

        let dot8 = new Dot(this.scene, this, dot0.x + 2*DX, dot0.y + 2*DY, 8)
        this.add(dot8)
        this.lockedContainer.add(dot8)

        this.scene.input.removeListener('pointerup')
        this.scene.input.on('pointerup', () => {
            // this.deleteCurrentLine()
            this.checkCode()
        })
        
    }

    createLine(dot, x, y){
        if(this.line)
            this.line.destroy(true);

        this.isDragging = true;
        let circle = this.scene.add.circle(dot.x, dot.y, 15, 0xffffff).setOrigin(0.5);
        let circle2 = this.scene.add.circle(dot.x, dot.y, 15, 0xffffff).setOrigin(0.5);
        dot.circle = circle2
        this.add(circle)
        this.add(circle2)
        this.linesGroup.add(circle)
        this.linesGroup.add(circle2)

        this.line = this.scene.add.line(dot.x, dot.y, dot.x, dot.y, x, y, 0xffffff).setOrigin(0);
        this.line.setLineWidth(30);
        this.line.dot = dot
        this.line.circle = circle
        this.add(this.line);
        this.linesGroup.add(this.line)

        this.lockedContainer.add(this.line);

        this.dots.push(dot)
    }

    addLinePoint(dot, x, y){
        if(!this.isDragging) return
        console.log("add line point", dot == this.line.dot)

        if(this.isDragging && dot == this.line.dot) return

        console.log("add line point")
        this.line.setTo(this.line.x1, this.line.y1, dot.x - this.line.x, dot.y - this.line.y)
        this.line.circle.destroy(true)
        this.line.dot.setConnected(true)

        this.line = undefined
        this.createLine(dot, x, y)
    }

    deleteCurrentLine(){
        if(this.line){
            console.log(this.lines)
            this.lines.splice(this.lines.indexOf(this.line), 1)
            if(this.lines.length == 0){
                this.line.dot.circle.destroy(true)
            }
            this.line.circle.destroy(true)
            this.line.destroy(true)
            this.line.dot.setConnected(false)
            this.line = undefined
        }
    }

    deleteLines(){
        this.dots.forEach( dot => {
            dot.reset()
        })
        this.dots = []
        this.linesGroup.clear(true, true);
    }

    // -- Code à rentrer
    checkCode(){
        this.isDragging = false;
        const code = "0367842"
        const code2 = "2487630"
        let currentCode = ""

        this.dots.forEach( dot => {
            currentCode += dot.id
        })

        if(code == currentCode || code2 == currentCode){
            this.setUnlocked()
            this.scene.closePopupOrdi();
            this.scene.input.removeListener('pointerup')
        }else{
            this.scene.cameras.main.shake(100, 0.02);
        }
        this.deleteLines()

        console.log(code, currentCode, code == currentCode)
    }

    setUnlocked(){
        // Update progression
        this.progression.locked = false;

        this.soundManager.playOnce('OrdiUnlocked')

        // Anim out
        this.scene.tweens.add({
            targets: this.lockedContainer,
            alpha: 0,
            duration: 500,
            onComplete: () => {
                this.lockedContainer.destroy(true);
                this.lockedContainer = null;

                this.scene.popupStart()
            }
        });

    }

    // Ajout liens externes sur le bureau de l'ordi
    addIcons(){
        const deltaY = 130

        Object.keys(this.config.liens).forEach( (icon, index) => {
            let iconElmt = this.scene.add.image(700, 204 + index * deltaY, icon).setOrigin(0.5);
            this.add(iconElmt)
            this.icons.push(iconElmt);

            iconElmt.setInteractive({useHandCursor: true})
            iconElmt.on('pointerup', () => {
                this.scene.tweens.add({
                    targets: iconElmt,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        window.open(this.config.liens[icon], '_blank');
                    }
                })
            })
        })
    }
}